<div data-test="status-list">
  <div class="title margin-top-sm">
    <span class="drag-handle"></span>
  </div>
  <div class="title margin-top-lg">
    Choose Status&nbsp;@if (totalActions) {
    <span>{{ currentActionStep }}/{{ totalActions + 1 }}</span>
  }
</div>
<div class="options margin-top-md center">
  @for (status of actions; track status) {
    <div
      [ngClass]="{ disabled: status.disabled || saving, current: status.type === 'current' }"
      class="margin-bottom-md"
      (click)="status.action()"
      data-test="status-name"
      >
      <span>{{ status.name }}</span>
      @if (status.type === 'current') {
        <span class="current-status" data-test="current-status-text"
          >Current status</span
          >
        }
      </div>
    }
  </div>
  @if (btnPodVisible) {
    <div>
      <button mat-button class="btn-accept" (click)="dismissBottomSheetToUpload()">Upload Proof Of Delivery</button>
    </div>
  }
</div>
